import React from "react";
import { Users } from "lucide-react";
import { formatIls } from "../../services/belvederePricing";

function PassengerLine({ line, formatPrice, renderPrice, priceSize = "sm", variant = "default" }) {
  const unitNode = renderPrice
    ? renderPrice(line.unitPriceIls, { size: priceSize })
    : formatPrice(line.unitPriceIls);
  const totalNode = renderPrice
    ? renderPrice(line.lineTotalIls, { size: priceSize })
    : formatPrice(line.lineTotalIls);

  if (variant === "receipt") {
    return (
      <div className="belvedere-passenger-pricing__line belvedere-passenger-pricing__line--receipt">
        <span className="belvedere-passenger-pricing__line-desc">
          <span className="belvedere-passenger-pricing__line-type">{line.labelHe}</span>
          <span className="belvedere-passenger-pricing__line-sep" aria-hidden>
            ·
          </span>
          <span className="belvedere-passenger-pricing__line-formula">
            {line.count} × {unitNode}
          </span>
        </span>
        <span className="belvedere-passenger-pricing__line-dots" aria-hidden />
        <strong className="belvedere-passenger-pricing__line-total">{totalNode}</strong>
      </div>
    );
  }

  return (
    <div className="belvedere-passenger-pricing__line">
      <div className="belvedere-passenger-pricing__line-head">
        <span className="belvedere-passenger-pricing__line-type">{line.labelHe}</span>
        <span className="belvedere-passenger-pricing__line-formula">
          {line.count} × {unitNode}
        </span>
      </div>
      <strong className="belvedere-passenger-pricing__line-total">{totalNode}</strong>
    </div>
  );
}

export default function CampaignPassengerPricingSummary({
  passengerPricing,
  formatPrice = formatIls,
  renderPrice = null,
  title = "מחיר לפי נוסע",
  showTitle = true,
  showPackageTotal = true,
  compact = false,
  priceSize = "sm",
  /** @type {"default" | "receipt"} */
  variant = "default",
}) {
  const lines = passengerPricing?.lines;
  if (!Array.isArray(lines) || lines.length === 0) return null;

  return (
    <div
      className={[
        "belvedere-passenger-pricing",
        compact ? "belvedere-passenger-pricing--compact" : "",
        variant === "receipt" ? "belvedere-passenger-pricing--receipt" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={title}
    >
      {showTitle ? (
        <p className="belvedere-passenger-pricing__title">
          <Users size={14} aria-hidden />
          {title}
        </p>
      ) : null}
      <div className="belvedere-passenger-pricing__lines">
        {lines.map((line) => (
          <PassengerLine
            key={line.type}
            line={line}
            formatPrice={formatPrice}
            renderPrice={renderPrice}
            priceSize={priceSize}
            variant={variant}
          />
        ))}
      </div>
      {showPackageTotal ? (
        <div className="belvedere-passenger-pricing__package-total">
          <span>סה״כ</span>
          <strong>
            {renderPrice
              ? renderPrice(passengerPricing.packageTotalIls, { size: priceSize })
              : formatPrice(passengerPricing.packageTotalIls)}
          </strong>
        </div>
      ) : null}
    </div>
  );
}
